import { FontIcon } from "@fluentui/react";
import { FunctionComponent } from "react";
import COLORES from "../../utils/theme/colores";

interface EstadoProps {
    value: string
}

export enum IPERC_ESTADOS {
    Rechazado = "Rechazado",
    Verificado = "Verificado",
    Pendiente = "Pendiente",
}
export enum CHECKLIST_ESTADOS {
    Activo = "Activo",
    Inactivo = "Inactivo",
}

export enum ESTADOS_ICON {
    Verificado = "SkypeCircleCheck",
    Pendiente = "AwayStatus",
    Rechazado = "StatusErrorFull",
    Indefinido = "StatusCircleBlock",
    Pendiente_MX = "Recent",
    Observado = "View",
    PendienteSupervisor = "TemporaryUser",
}

export enum CHECKLIST_ESTADOS_DB {
    PENDIENTE_MX = "Pendiente MX",
    VERIFICADO = "Verificado",
    OBSERVADO = "Observado",
    PENDIENTE_SUPERVISOR = "Pendiente Supervisor",
    Pendiente_Sup_Mantto = "Pendiente Sup. Mantto"
}
export enum CHECKLIST_ESTADOS_CODIGOS {
    PENDIENTE_MX = "04",
    VERIFICADO = "03",
    OBSERVADO = "02",
    PENDIENTE_SUPERVISOR = "01"
}
// export declare type IPERC_ESTADOS = 'Rechazado' | 'Verificado' | 'Pendiente';


const Estado: FunctionComponent<EstadoProps> = (prop) => {
    let resul = { color: "", iconName: "" }
    switch (prop.value) {
        case IPERC_ESTADOS.Pendiente:
            resul = { color: COLORES.Messaging.Away, iconName: ESTADOS_ICON.Pendiente }
            break;
        case IPERC_ESTADOS.Verificado:
            resul = { color: COLORES.Messaging.SuccessIcon, iconName: ESTADOS_ICON.Verificado }
            break;
        case IPERC_ESTADOS.Rechazado:
            resul = { color: COLORES.Messaging.SevereWarningIcon, iconName: ESTADOS_ICON.Rechazado }
            break;
        case CHECKLIST_ESTADOS.Activo:
            resul = { color: COLORES.Messaging.SuccessIcon, iconName: ESTADOS_ICON.Verificado }
            break;
        case CHECKLIST_ESTADOS.Inactivo:
            resul = { color: COLORES.Messaging.ErrorBlockIcon, iconName: ESTADOS_ICON.Indefinido }
            break;
        case CHECKLIST_ESTADOS_DB.VERIFICADO:
            resul = { color: COLORES.Messaging.SuccessIcon, iconName: ESTADOS_ICON.Verificado }
            break;
        case CHECKLIST_ESTADOS_DB.OBSERVADO:
            resul = { color: COLORES.Messaging.ErrorBlockIcon, iconName: ESTADOS_ICON.Observado }
            break;
        case CHECKLIST_ESTADOS_DB.PENDIENTE_MX:
            resul = { color: COLORES.Messaging.waitingIcon, iconName: ESTADOS_ICON.Pendiente_MX }
            break;
        case CHECKLIST_ESTADOS_DB.PENDIENTE_SUPERVISOR:
            resul = { color: COLORES.Bases.ambar, iconName: ESTADOS_ICON.Pendiente }
            break;
        case CHECKLIST_ESTADOS_DB.Pendiente_Sup_Mantto:
            resul = { color: COLORES.Messaging.waitingIcon, iconName: ESTADOS_ICON.Pendiente }
            break;
        default:
            resul = { color: "#000", iconName: ESTADOS_ICON.Indefinido }
            break;
    }
    return (
        <div style={{ verticalAlign: 'start' }}>
            <FontIcon iconName={resul.iconName} style={{ color: resul.color, marginRight: 4 }} />
            {(prop.value === CHECKLIST_ESTADOS_DB.PENDIENTE_SUPERVISOR || prop.value === IPERC_ESTADOS.Pendiente) ?
                <span>{prop.value}</span>
                : <span style={{ color: resul.color }}>{prop.value}</span>
            }
        </div>
    );
}

export default Estado;